module.exports = __webpack_public_path__ + "img/Ashely-Irving-Portrait-3.67980082.67980082.jpg";